window.addEventListener("load", function () {
   
});